import React from "react";

export default function TransIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: "20px",
        height: "20px",
        marginLeft: "0.3rem",
      }}
      fill="#fcfcfc"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <polygon
        points="24 96 232 96 128 32 24 96"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polygon>
      <line
        x1="56"
        y1="96"
        x2="56"
        y2="168"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <line
        x1="104"
        y1="96"
        x2="104"
        y2="168"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <line
        x1="152"
        y1="96"
        x2="152"
        y2="168"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <line
        x1="200"
        y1="96"
        x2="200"
        y2="168"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <line
        x1="32"
        y1="168"
        x2="224"
        y2="168"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <line
        x1="16"
        y1="208"
        x2="240"
        y2="208"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
    </svg>
  );
}
